import { IconButton } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

interface IProps {
  onClick: () => void;
  sx?: SxProps<Theme>;
}

const CloseButton = (props: IProps) => {
  return (
    <IconButton {...props} aria-label='close'>
      <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M15 1L1 15M15 15L1 1' stroke='#727279' strokeWidth='2' strokeLinecap='round' />
      </svg>
    </IconButton>
  );
};

export default CloseButton;
